import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose, withState } from 'recompose'

import { dataFetched, makesQueries } from 'data/graphql'

const InvoicesListQuery = gql`
  query InvoicesList {
    listInvoices {
      __typename
      id
      amount
      number
      pdfUrl
      date
      status
    }
  }
`

const providesInvoicesList = compose(
  connect(
    null,
    { dataFetched }
  ),
  withState('invoicesFetchState', 'setFetchState', {
    loading: false,
    error: false,
    pristine: true,
  }),
  makesQueries({
    query: InvoicesListQuery,
    getOnQueryFromProps: ({ setFetchState }) => () =>
      setFetchState({ loading: true, error: null, pristine: false }),
    getOnResultFromProps: ({ dataFetched, setFetchState }) => ({
      result,
      meta,
    }) => {
      dataFetched(result.data.listInvoices, meta)
      setFetchState({ loading: false, error: null })
    },
    getOnErrorFromProps({ setError, setFetchState }) {
      return ({ error }) => {
        setFetchState({ loading: false, error })
      }
    },
  })
)

export default providesInvoicesList
